var React = require('react');

function IconHamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("path",{"fill":"#343434","d":"M21.12 6H2.87c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h18.25c.414 0 .75.336.75.75s-.336.75-.75.75zm.75 6c0-.414-.336-.75-.75-.75H2.87c-.414 0-.75.336-.75.75s.336.75.75.75h18.25c.414 0 .75-.336.75-.75zm0 6.5c0-.414-.336-.75-.75-.75H2.87c-.414 0-.75.336-.75.75s.336.75.75.75h18.25c.414 0 .75-.336.75-.75z"})));
}

IconHamburger.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconHamburger;

IconHamburger.default = IconHamburger;
